import Popover from 'trunks/vue/admin/components/libs/popover.js'
import { newAlertify } from 'trunks/vue/admin/components/alert.js'
import TopOrganizationModal from './top_organization_modal.js'

export default Vue.extend({
  components: {
    Popover
  },

  props: {
    namespace: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      topOrganizations: [],
      superiors: [],
      loading: true
    }
  },

  template: `
    <div class="panel-card namespaces-subpanel">
      <div class="panel-card-head">
        <span class="panel-card-title">顶级组织</span>
        <div class="panel-card-actions">
          <button class="text-btn btn-primary" @click="openCreate" :disabled="superiors.length === 0">
            <i class="slp-plus-circle"></i>
            <span>{{ superiors.length === 0 ? '需先创建超管' : '创建顶级组织' }}</span>
          </button>
        </div>
      </div>
      <div class="panel-card-body">
        <div v-if="loading" class="text-muted">加载中...</div>
        <div v-else-if="topOrganizations.length === 0" class="text-muted">尚未创建顶级组织</div>
        <table v-else class="table table-noborder table-striped">
          <thead>
            <tr>
              <th class="num-col">ID</th>
              <th>名称</th>
              <th>创建者</th>
              <th class="operation-col">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="org in topOrganizations" :key="org.id">
              <td class="num-col">{{ org.id }}</td>
              <td>
                <div>{{ org.name }}</div>
                <div class="text-muted" v-if="org.description">{{ org.description }}</div>
              </td>
              <td>
                <span class="mr-2">{{ org.founder ? org.founder.name : '—' }}</span>
                <a v-if="org.founder"
                   :href="loginUrl(org.founder)"
                   data-method="post"
                   rel="nofollow"
                   data-turbolinks="false"
                   class="btn-text primary-text">登录</a>
              </td>
              <td class="operation-col">
                <span class="btn-text primary-text mr-3" @click="openEdit(org)">编辑</span>
                <Popover position="bottom right"
                         customClass="confirm table-operation-confirm-popover delete-confirm-popover"
                         :ref="deleteRefName(org)">
                  <template slot="trigger">
                    <span class="btn-text error-text">删除</span>
                  </template>
                  <template slot="content">
                    <div class="popover-confirm-content">
                      <div class="popover-confirm-title">确定删除顶级组织？</div>
                      <div class="popover-confirm-message text-danger">将同时删除其下所有子组织和成员关系。</div>
                      <div class="popover-confirm-footer">
                        <span class="btn btn-small btn-default outlined" @click.stop="closeDelete(org)">取消</span>
                        <span class="btn btn-small btn-danger" @click.stop="destroyTopOrganization(org)">删除</span>
                      </div>
                    </div>
                  </template>
                </Popover>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  `,

  created() {
    this._fetchTopOrganizations()
    this._fetchSuperiors()
  },

  methods: {
    _fetchTopOrganizations() {
      this.loading = true
      Skylark.Libs.Ajax.get(`${this.namespace.urls.top_organizations}.json`, {
        responseType: 'json',
        success: (data) => {
          this.topOrganizations = data || []
        },
        complete: () => {
          this.loading = false
        }
      })
    },

    _fetchSuperiors() {
      Skylark.Libs.Ajax.get(`${this.namespace.urls.superiors}.json`, {
        responseType: 'json',
        success: (data) => {
          this.superiors = data || []
        }
      })
    },

    loginUrl(user) {
      return `/admin/login_as_root/${user.id}`
    },

    deleteRefName(org) {
      return `deletePopover-${org.id}`
    },

    closeDelete(org) {
      const ref = this.$refs[this.deleteRefName(org)]
      const popover = Array.isArray(ref) ? ref[0] : ref
      if (popover) popover.close()
    },

    openCreate() {
      if (this.superiors.length === 0) {
        newAlertify('请先创建超级管理员', { type: 'error' })
        return
      }

      new TopOrganizationModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('top_organization_create_modal_container'),
        propsData: {
          namespace: this.namespace,
          mode: 'create',
          superiors: this.superiors,
          onSuccess: (data) => {
            this.topOrganizations = [data].concat(this.topOrganizations)
          }
        }
      })
    },

    openEdit(org) {
      new TopOrganizationModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('top_organization_edit_modal_container'),
        propsData: {
          namespace: this.namespace,
          mode: 'edit',
          topOrganization: _.clone(org),
          superiors: this.superiors,
          onSuccess: (data) => {
            const index = _.findIndex(this.topOrganizations, { id: data.id })
            if (index >= 0) Vue.set(this.topOrganizations, index, data)
          }
        }
      })
    },

    destroyTopOrganization(org) {
      Skylark.Libs.Ajax.delete(`${this.namespace.urls.top_organizations}/${org.id}`, {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        success: () => {
          this.topOrganizations = this.topOrganizations.filter((item) => item.id !== org.id)
          newAlertify('已删除顶级组织', { type: 'success' })
        },
        error: () => {
          newAlertify('删除失败，请重试', { type: 'error' })
        },
        complete: () => {
          this.closeDelete(org)
        }
      })
    }
  }
})
